import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
// import { Select } from "reactstrap";
import Select from "react-select";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "../../../../../components/dashboard/dashboard.css";
import "bootstrap/dist/css/bootstrap.min.css";

import httpService from "../../../../../services/http.service";
import ErrorMessage from "../../../../common/errorMsg";
import SuccessMessage from "../../../../common/successMsg";

function ViewSelectRull(props) {
    const [ruleSecledValue, setRuleSecledValue] = useState([])
    const [channelRuleName, setchannelRuleName] = useState([])
    const [onClickDelete, setOnclickDelete] = useState('');
    const [array3, setarray3] = useState([])
    const [ruleForProperty, setRuleForProperty] = useState("");
    const [channelIdforRule, setchannelIdforRule] = useState("");


    // const channelIdforRule = () => {

    // }
    // const ruleForProperty = () => {

    // }





    const handleselectedR = (selectedValue) => {
        console.log(selectedValue, "seletct")
        let dataArrr = [];
        for (let j = 0; j < selectedValue.length; j++) {
            dataArrr.push(selectedValue[j]);
        };
        props.setRuleSecledValue(dataArrr);
    }


    const UpdateChannelruleForChannel = async (e, ruleDelete) => {
        e.preventDefault();
        if (props.ruleSecledValue.length === 0) {
            ErrorMessage('Please select a Rule !')
            return;
        }
        //validation for 'deselecting a rule' or 'not selecting a rule' or 'deselecting and then selecting a rule'
        // showLoader();
        let data = {
            id: props.channelIdforRule,
            ruleForProperty: props.ruleForProperty,
            ruleDelete: ruleDelete,
            channelRules: props.ruleSecledValue,
        };
        const res = await httpService.CreateUpdate("UpdateChannelRuleforChannel", data)
            .catch((err) => {
                return;
            });
        props.setchannelIdforRule("");
        // setchannelRuleExisting("");
        // loadProperty();
        // loadAlldata();
        // setShowRule(false);
        props.handleCloseRule()
        if (res?.data?.message === "Successful") {
            SuccessMessage("Selected rule updated successfully")
            //   hideLoader();
            return;
        }
    }


    useEffect(async () => {
        let dataUserPost = localStorage.getItem("UserId");
        let reqAllData = {
            UserId: dataUserPost,
        };
        console.log(reqAllData, "getallrulebyuser")
        let LayoutArraydata = await httpService
            .CreateUpdate("getallrulebyuser", { reqAllData })
            .catch((err) => {
                return;
            });

        let arr2 = []
        for (let i = 0; i < LayoutArraydata?.data?.data?.length; i++) {
            console.log(LayoutArraydata?.data?.data, "getallrulebyuser")
            let obj = {
                value: `${LayoutArraydata?.data?.data[i]._id}`,
                label: `${LayoutArraydata?.data?.data[i].ChannelRulesName}`,
                id: `${LayoutArraydata?.data?.data[i]._id}`,
            };
            if (LayoutArraydata?.data?.data[i]) {
                console.log(obj, "getallrulebyuser")
                {
                    if (
                        LayoutArraydata?.data?.data[i].ChannelRulesName != undefined &&
                        LayoutArraydata?.data?.data[i].ChannelRulesName != ""
                    ) {
                        {
                            arr2.push(obj);
                        }
                    }
                }
            }
        }
        setarray3(arr2)

    }, [])
    return (<Modal show={props.showRule} onHide={props.handleCloseRule}>
        <Modal.Header closeButton>
            <Modal.Title>
                {onClickDelete ? "Edit Rule" : "Select Rule"}
            </Modal.Title>
        </Modal.Header>
        <div className="ui main">
            <form className="ui form">
                <div className="field">
                    <label>Select Channel Rule</label>
                    <Select
                        isMulti
                        name="Rule Name"
                        options={array3}
                        placeholder="Choose Rule..."
                        defaultValue={props.ruleSecledValue}
                        onChange={(event) => { handleselectedR(event); }}
                        className="basic-multi-select"
                        classNamePrefix="select" />
                </div>

            </form>
        </div>
        <Modal.Footer>
            <Button color="success" onClick={(e) => {
                UpdateChannelruleForChannel(e);
                setchannelRuleName('');
            }}>
                {onClickDelete ? "Update" : "Save"}
            </Button>
            <Button
                // className="btn-danger !important"
                // style={{background:'#dc3545 !important'}}
                variant="danger"
                onClick={() => {
                    // setShowRule(false);
                    setchannelRuleName('');
                    props.handleCloseRule()
                }}
            >
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>);
}

export default ViewSelectRull;

